import * as model from "@/model/prd/productionExecution/pelletizing/PelletizingProductionResult";
import { newEntityStoreHelper } from "@/store/common/entityModule";

import router from "@/router/index";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}


export default newEntityStoreHelper(() => new model.PelletizingProductionResult(), newFilter)
    .withStates({
        idReport: 2,

        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd"
    }) //TODO load at the application start    
    .withActions({  
        jumpToPelletEnergyCost(context, entity) {
            router.push("/prd/pelletizingEnergyCost");                       
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/pelletizingEnergyCost/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    //调试语句，用console
                    //console.log(response.list);
                    context.commit('pelletizingEnergyCost' + "/setRows", response.list, { root: true });                                    
                }       
            });       
        },

        jumpToPelletMatCost(context, entity) {
            router.push("/prd/pelletizingMaterialCost");                       
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/pelletizingMaterialCost/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('pelletizingMaterialCost' + "/setRows", response.list, { root: true });                                    
                }       
            });       
        },

        jumpToPelletProductInfo(context, entity) {
            router.push("/prd/pelletizingProductInfo");                       
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/pelletizingProductInfo/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {                    
                    context.commit('pelletizingProductInfo' + "/setRows", response.list, { root: true });                                    
                }       
            });       
        },

        jumpToPelletProductQuality(context, entity) {
            router.push("/prd/pelletizingProductionQuality");
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/pelletizingProductionQuality/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('pelletizingProductionQuality' + "/setRows", response.list, { root: true });                                    
                }       
            });     
            // router.push("/prd/pelletizingProductQuality");                       
            // context.dispatch("api/get", {
            //     url: context.state.baseModuleUrl + "/pelletizingProductQuality/findByPlanCode/" + entity.planCode
            // },{ root: true })
            // .then(response => {
            //     //seting the values
            //     {
            //         context.commit('pelletizingProductQuality' + "/setRows", response.list, { root: true });                                    
            //     }       
            // });       
        },

        jumpToPelletEquipPara(context, entity) {
            router.push("/prd/pelletizingEquipPara");                       
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/pelletizingEquipPara/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('pelletizingEquipPara' + "/setRows", response.list, { root: true });                                    
                }       
            });       
        },

        updateData(context, row){
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/pelletizingProductionResult/updateData/" + row.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('pelletizingProductionResult' + "/setRows", [response], { root: true });                                    
                }       
            });
        }
    })
    .buildStore()